/**
 * Storezone — useAuth Hook
 *
 * Provides access to the AuthContext.
 * Must be used inside <AuthProvider>.
 */

import { useContext } from 'react'
import { AuthContext, type AuthContextValue } from '@/contexts/AuthContext'

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
